import React, { useState, useEffect } from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import Works from '../components/Works';
import Sculptures from '../components/Sculptures';
import About from '../components/About';
import Contact from '../components/Contact';
import Footer from '../components/Footer';
import Cart from '../components/Cart';
import WhatsAppButton from '../components/WhatsAppButton';
import NewsletterPopup from '../components/NewsletterPopup';
import CatalogBanner from '../components/CatalogBanner';
import { trackPageView } from '../utils/track';

const SITE_DEFAULT_TITLE = 'C. LLAGUNO — Contemporary Artist';
const SITE_DEFAULT_DESC = 'C. LLAGUNO — luxury contemporary art. Original paintings and White Dolls sculptures. Beauty hidden inside chaos.';
const SITE_DEFAULT_IMAGE = 'https://customer-assets.emergentagent.com/job_studio-llaguno/artifacts/o1ung218_IMG_2114.jpeg';

const resetSiteMeta = () => {
  if (typeof document === 'undefined') return;
  document.title = SITE_DEFAULT_TITLE;
  const set = (attr, key, value) => {
    let el = document.head.querySelector(`meta[${attr}="${key}"]`);
    if (!el) {
      el = document.createElement('meta');
      el.setAttribute(attr, key);
      document.head.appendChild(el);
    }
    el.setAttribute('content', value);
  };
  const siteUrl = (typeof window !== 'undefined' && window.location.origin) || '';

  set('name', 'description', SITE_DEFAULT_DESC);
  set('property', 'og:type', 'website');
  set('property', 'og:title', SITE_DEFAULT_TITLE);
  set('property', 'og:description', SITE_DEFAULT_DESC);
  set('property', 'og:url', siteUrl || 'https://cllaguno.com/');
  set('property', 'og:image', SITE_DEFAULT_IMAGE);
  set('property', 'og:site_name', 'C. LLAGUNO');
  set('name', 'twitter:card', 'summary_large_image');
  set('name', 'twitter:title', SITE_DEFAULT_TITLE);
  set('name', 'twitter:description', SITE_DEFAULT_DESC);
  set('name', 'twitter:image', SITE_DEFAULT_IMAGE);

  // Clear product-specific tags that may linger from an artwork page
  ['product:price:amount', 'product:price:currency', 'og:price:amount', 'og:price:currency', 'product:availability'].forEach((k) => {
    const el = document.head.querySelector(`meta[property="${k}"]`);
    if (el) el.parentNode.removeChild(el);
  });

  // Canonical -> site root
  let link = document.head.querySelector('link[rel="canonical"]');
  if (!link) {
    link = document.createElement('link');
    link.setAttribute('rel', 'canonical');
    document.head.appendChild(link);
  }
  link.setAttribute('href', siteUrl || 'https://cllaguno.com/');
};

const scrollToHash = () => {
  if (typeof window === 'undefined' || !window.location.hash) return;
  const id = window.location.hash.replace('#', '');
  // Retry until the target is stable (images finish loading and grow the doc)
  let attempts = 0;
  const tick = () => {
    const el = document.getElementById(id);
    if (!el) {
      if (++attempts < 30) setTimeout(tick, 150);
      return;
    }
    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    if (++attempts < 8) setTimeout(tick, 400);
  };
  setTimeout(tick, 120);
};

const HomePage = () => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    setIsLoaded(true);
    trackPageView();
    resetSiteMeta();
    scrollToHash();
  }, []);

  return (
    <div className={`homepage ${isLoaded ? 'loaded' : ''}`}>
      <Header />
      <Hero />
      <CatalogBanner position="top" />
      <Works />
      <CatalogBanner position="bottom" />
      <Sculptures />
      <About />
      <Contact />
      <Footer />
      <Cart />
      <WhatsAppButton />
      <NewsletterPopup />
    </div>
  );
};

export default HomePage;
